import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: inherit;

  @media screen and (max-width: 960px) {
    text-align: center;
  }

  .textDiv {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    color: ${(props) => props.theme.colors.black};
  }
`;
